import { atom, createStore } from 'jotai/vanilla';
import { useAtom } from 'jotai/react';
import { UserWithFeatures } from 'types/auth/user-context.type';
import { SecurityAccessFeaturesEnum } from 'bff/client';
import { canAccessAll, canAccessAny } from './can-access';

interface UserContextManagerApiType {
  getCurrentAuthenticatedUser: () => UserWithFeatures | undefined;
  setCurrentAuthenticatedUser: (actingAsUser: UserWithFeatures | undefined) => void;
  getUserFeatures: () => SecurityAccessFeaturesEnum[];
  canAccessAll: (features: SecurityAccessFeaturesEnum | SecurityAccessFeaturesEnum[]) => boolean;
  canAccessAny: (features: SecurityAccessFeaturesEnum | SecurityAccessFeaturesEnum[]) => boolean;
}

const currentUserAtom = atom<UserWithFeatures | undefined>(undefined);

const store = createStore();

export const useUserContext = () => {
  const [currentUser, setCurrentUser] = useAtom(currentUserAtom, { store });

  const getFeatures = () => {
    return currentUser?.features ?? [];
  };

  const api: UserContextManagerApiType = {
    getCurrentAuthenticatedUser: () => currentUser,
    setCurrentAuthenticatedUser: (user: UserWithFeatures | undefined) => {
      setCurrentUser(user);
    },
    getUserFeatures: getFeatures,
    canAccessAll: (features: SecurityAccessFeaturesEnum | SecurityAccessFeaturesEnum[]) => {
      const userFeatures = getFeatures();
      return canAccessAll(features, userFeatures);
    },
    canAccessAny: (features: SecurityAccessFeaturesEnum | SecurityAccessFeaturesEnum[]) => {
      const userFeatures = getFeatures();
      return canAccessAny(features, userFeatures);
    }
  };

  return api;
};
